import {Injectable, inject} from '@angular/core';
import {ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree} from '@angular/router';
import {Observable} from 'rxjs';
import {GuiPermissionsService} from '../_services/gui/gui-permissions.service';
import {switchMapIfFalse} from '../_utils/operators';

/**
 * This guard is used on the root admin path.  The root admin path itself only has child routes.
 * It essentially only needs to answer if a user is able to do the company/user searches across all of TU Direct.
 *
 * As of writing, this is limited to TU Admins and also Operators
 */
@Injectable({
  providedIn: 'root'
})
export class AdminSearchGuard  {
  private readonly guiPermissionsService = inject(GuiPermissionsService);


  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return switchMapIfFalse(this.guiPermissionsService.canViewAdminSearch$, this.guiPermissionsService.companyAdminRedirectUrlTree$);
  }

}
